export default __webpack_public_path__ + "static/media/icaew_xl.eb2acdd8.jpg";